import { Box, Button } from '@mui/material';
import { useAppSelector } from '../../app/hooks';
import { useBuildScanDataMutation } from '../../services/entities/impl/blfApi/endpoints/debug';
import { flexCenter } from '../commonUI/cssClasses';
import { selectCurrScanID } from '../select/selectSlice';

const BuildScanDataButton: React.FC = () => {
  const currScanID = useAppSelector(selectCurrScanID);

  const [buildScanData, { isLoading }] = useBuildScanDataMutation();

  const handleBuildScanData = () => {
    buildScanData(currScanID);
  };

  return (
    <Box sx={{ ...flexCenter, flexDirection: 'row' }}>
      <Button
        variant='contained'
        color='secondary'
        onClick={handleBuildScanData}
        disabled={isLoading}
        sx={{ marginLeft: '1rem', p: '0.2rem 0.75rem' }}
      >
        Build Scan Data
      </Button>
    </Box>
  );
};

export default BuildScanDataButton;
